import { centralizedAuth } from '@cimpress/simple-auth-wrapper';

export const CLIENT_ID = 'ZXmAaQFCHGExF5C83AzXDd5ii4HPFnyJ';
const auth = new centralizedAuth({
  clientID: CLIENT_ID,
  redirectRoute: '/',
});

export default auth;
